export default {
  SIGNUP_STEP_SET(state, step) {
    state.step = step;
  },
}